<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields"
      :permission="permission" :buttons="buttons" :searchs="searchs" @returnId="returnId" @vieoUpdate="vieoUpdate"
      ref="table"></common-table>
    <div class="dialog">
      <el-dialog title="批量发布" :visible.sync="batchVisible" custom-class="common-dialog" :close-on-click-modal="false"
        @close="resetForm('batchForm')" width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="90px" :model="batchForm" ref="batchForm">
            <el-form-item label="cookies名称" prop="cookiesName"
              :rules="[{ required: true, message: 'cookies名称不能为空', trigger: 'blur' }]">
              <el-input v-model="batchForm.cookiesName" placeholder="请输入cookies名称"></el-input>
            </el-form-item>

            <el-form-item label="手机号:" prop="userId" :rules="[{ required: true, message: '手机号不能为空', trigger: 'blur' }]">
              <el-select filterable v-model="batchForm.userId" clearable placeholder="请选择会员" size="medium"
                class="mr10 mb-10">
                <el-option v-for="(option, index) in userIds" :key="index" :label="option.username"
                  :value="option.id" />
              </el-select>
            </el-form-item>


            <!--            <el-form-item label="平台:" prop="ADSUserId"
                                      :rules="[{ required: true, message: '平台不能为空', trigger: 'blur'}]">
                          <el-select
                              filterable
                              v-model="batchForm.ADSUserId"
                              clearable
                              placeholder="请选择平台"
                              size="medium"
                              class="mr10 mb-10"
                              style="margin-top: 10px;"
                          >
                            <el-option
                                value="1"
                                label="抖音"
                            />
                            <el-option
                                value="2"
                                label="快手"
                            />
                          </el-select>
                        </el-form-item>-->

          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="batchVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitBatch('batchForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="dialog">
      <el-dialog title="批量修改抖音号" :visible.sync="batchUpdateDouYinIdVisible" custom-class="common-dialog"
        :close-on-click-modal="false" @close="resetForm('batchForm')" width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="90px" :model="batchForm" ref="batchForm">
            <el-form-item label="抖音号" prop="douYinId"
              :rules="[{ required: true, message: '抖音号不能为空', trigger: 'blur' }]">
              <el-input v-model="batchForm.douYinId" placeholder="请输入抖音号"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="batchUpdateDouYinIdVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitDouYinIdBatch('batchForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="dialog">
      <el-dialog title="批量修改Cookies" :visible.sync="batchUpdateCookiesVisible" custom-class="common-dialog"
        :close-on-click-modal="false" @close="resetForm('batchCookiesForm')" width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="90px" :model="batchCookiesForm"
            ref="batchCookiesForm">
            <el-form-item label="Cookies名称" prop="cookiesName"
              :rules="[{ required: true, message: 'Cookies不能为空', trigger: 'blur' }]">
              <el-input v-model="batchCookiesForm.cookiesName" placeholder="请输入Cookies"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="batchUpdateCookiesVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitCookiesBatch('batchCookiesForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="dialog">
      <el-dialog title="播放视频" :visible.sync="showVideoVisible" custom-class="common-dialog"
        :close-on-click-modal="false" width="30%">
        <video class="product_video" :loop="true" controls :autoplay="true" :src="videoSrc"></video>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button size="small" @click="showVideoVisible = false">取 消</el-button> -->
          <el-button type="primary" size="small" @click="showVideoVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="dialog">
      <el-dialog title="选择导出时间" :visible.sync="exportVisible" custom-class="common-dialog" :close-on-click-modal="false"
        @close="resetForm('form')" width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="90px" :model="form" ref="form">
            <el-form-item label="代理" prop="agentId" :rules="[{ message: '请选择代理', trigger: 'blur', required: false }]">
              <el-select filterable v-model="form.agentId" clearable placeholder="请选择代理" size="medium"
                class="mr10 mb-10">
                <el-option v-for="(option, index) in agents" :key="index" :label="option.name" :value="option.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Cookies名称" prop="cookiesNameList"
              :rules="[{ required: false, message: 'Cookies不能为空', trigger: 'blur' }]">
              <el-input v-model="form.cookiesNameList" placeholder="请输入Cookies名称,多个请用”,“隔开"></el-input>
            </el-form-item>
            <el-form-item label="状态:" prop="status" :rules="[{ required: false, message: '状态不能为空', trigger: 'blur' }]">
              <el-select filterable v-model="form.status" clearable placeholder="请选择状态" size="medium" class="mr10 mb-10"
                style="margin-top: 10px;">
                <el-option value="1" label="添加标签中" />
                <el-option value="4" label="视频已采集" />
                <el-option value="3" label="预发布" />
                <el-option value="5" label="发布中" />
                <el-option value="2" label="发布成功" />
                <el-option value="0" label="发布失败" />
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间" prop="startCreateTime"
              :rules="[{ message: '请选择开始时间', trigger: 'blur', required: true }]">
              <el-date-picker v-model="form.startCreateTime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss"
                type='datetime' align="right" size="medium" class="mr10 mb-10" />
            </el-form-item>
            <el-form-item label="结束时间" prop="endCreateTime"
              :rules="[{ message: '请选择结束时间', trigger: 'blur', required: true }]">
              <el-date-picker v-model="form.endCreateTime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
                type='datetime' align="right" size="medium" class="mr10 mb-10" />
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="exportVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submit('form')">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="dialog">
      <el-dialog title="AI生成图片选择" :visible.sync="aiGenerateVisible" custom-class="common-dialog"
        :close-on-click-modal="false" @close="resetAIGenerateForm" width="60%">
        <div class="dialog_body dialog_body_aiCreate">
          <el-form label-position="right" status-icon label-width="90px" :model="aiGenerateForm" ref="aiGenerateForm">
            <div class="coverImg ">
              <div>
                <div class="coverBox">
                  <div class="coverImg_text">封面</div>
                </div>
                <el-radio v-model="chooseImage" label="fengmian">
                  <img :src="coverImg" style="width: 200px; height: auto;">
                </el-radio>
              </div>
            </div>
            <div class="coverBox">
              <div class="coverTextBox">
                <div class="coverImg_text">素材图片</div>
              </div>
            </div>
            <div class="totalImgBox">
              <div class="noDataText" v-if="!aiGenerateImages.length">暂无数据</div>
              <div class="radioBox" v-for="(image, index) in aiGenerateImages" :key="index">
                <el-radio v-model="chooseImage" :label="index">
                  <img :src="image.imageUrl" style="width: 200px; height: auto;">
                </el-radio>
              </div>
            </div>
            <el-form-item label="使用AI提示">
              <el-checkbox v-model="aiGenerateForm.aiPrompt"></el-checkbox>
            </el-form-item>
            <div class="coverBox">
              <el-input class="input_ai" v-model="aiCreateWord" placeholder="请输入生成提示词"></el-input>
              <el-input class="input_ai" v-model="generateQuantity" placeholder="请输入生成数量"></el-input>
            </div>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click='aiGenerateVisible = false; aiCreateWord = null'>取 消</el-button>
          <el-button type="primary" size="small" @click="submitAIGenerateForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="dialog">
      <el-dialog title="批量修改代理" :visible.sync="batchUpdateAgent" custom-class="common-dialog"
        :close-on-click-modal="false" @close="resetForm('batchForm')" width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="90px" :model="batchAgent" ref="batchForm">
            <el-form-item label="代理:" prop="agentId" :rules="[{ required: true, message: '代理不能为空', trigger: 'blur' }]">
              <el-select filterable v-model="batchAgent.agentId" clearable placeholder="请选择代理" size="medium"
                class="mr10 mb-10">
                <el-option v-for="(option, index) in agents" :key="index" :label="option.username" :value="option.id" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="batchUpdateAgent = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitAgent('batchForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
  name: "DouYinRelease",
  components: { CommonTable },
  data() {
    return {
      aiCreateWord: '',
      generateQuantity: '',
      batchVisible: false,
      batchForm: {
        ids: '',
        ADSUserId: '',
        cookiesName: '',
        douYinId: '',
        userId: ''
      },
      batchAgent: {
        ids: '',
        agentId: ''
      },
      agents: [],
      exportVisible: false,
      form: {
        startCreateTime: '',
        endCreateTime: '',
        cookiesNameList: '',
        agentId: '',
        status: ''
      },
      batchUpdateDouYinIdVisible: false,
      batchUpdateAgent: false,
      batchUpdateCookiesVisible: false,
      showVideoVisible: false,
      videoSrc: '',
      batchCookiesForm: {
        ids: '',
        cookiesName: ''
      },
      userIds: [],//用户id集合
      selectIds: [],
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'productTemplateNumber',
        placeholder: '模板名称',
        type: 'select',
        selectUrl: '/productTemplate/getAll',
        selectData: [],
      }, {
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      }, {
        name: 'videoTitle',
        placeholder: '视频标题',
        type: 'input'
      }, {
        name: 'keyWord',
        placeholder: '关键词',
        type: 'input'
      }, {
        name: 'douYinId',
        placeholder: '抖音号',
        type: 'input'
      }, {
        name: 'cookiesName',
        placeholder: 'cookies名称',
        type: 'input'
      }, {
        name: 'status',
        placeholder: '状态',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '添加标签中',
        }, {
          key: 4,
          value: '视频已采集',
        }, {
          key: 3,
          value: '预发布',
        }, {
          key: 5,
          value: '发布中',
        }, {
          key: 2,
          value: '发布成功',
        }, {
          key: 6,
          value: '预约中',
        }, {
          key: 0,
          value: '发布失败',
        }]
      }, {
        name: 'publishType',
        placeholder: '发布类型',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '短视频',
        }, {
          key: 2,
          value: '图文',
        }]
      }, {
        name: 'platformType',
        placeholder: '平台类型',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '抖音',
        }, {
          key: 2,
          value: '快手',
        }]
      }, {
        name: 'productCategoryId',
        placeholder: '商品类别',
        type: 'select',
        selectUrl: '/productCategory/getAll',
        selectData: [],
      }, {
        name: 'callbackLog',
        placeholder: '回调日志',
        type: 'input'
      }, {
        name: 'startTime',
        placeholder: '回调开始时间',
        type: 'dateTime'
      },
      {
        name: 'endTime',
        placeholder: '回调结束时间',
        type: 'dateTime'
      },
      {
        name: 'startCreateTime',
        placeholder: '开始时间',
        type: 'dateTime'
      },
      {
        name: 'endCreateTime',
        placeholder: '结束时间',
        type: 'dateTime'
      }, {
        name: 'isBigVideo',
        placeholder: '文件大小',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '大文件',
        }, {
          key: 0,
          value: '小文件',
        }]
      }, {
        name: 'videoType',
        placeholder: '视频类型',
        type: 'select',
        selectValue: [{
          key: 0,
          value: '二创',
        }, {
          key: 1,
          value: 'AI视频',
        }]
      }, {
        name: 'devicesId',
        placeholder: '设备信息',
        type: 'select',
        selectUrl: '/devices/getAll',
        selectData: [],
      }],
      permission: {
        add: 'douYinRelease:add',
        update: 'douYinRelease:update',
        delete: 'douYinRelease:delete',
        deleteBatch: 'douYinRelease:deleteBatch'
      },
      url: {
        get: '/douYinRelease/listByCondition',
        add: '/douYinRelease/add',
        update: '/douYinRelease/update',
        delete: '/douYinRelease/delete/',
        delete_batch: '/douYinRelease/deleteBatch',
        status: '/douYinRelease/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        detail: true,
      }, {
        field: 'videoId',
        label: '视频片段ID',
        show: false,
        detail: false,
      }, {
        field: 'videoTitle',
        label: '标题',
        show: true,
      }, {
        field: 'productTemplateTitle',
        label: '模板标题',
        show: false,
        detail: true,
      }, {
        field: 'videoPath',
        label: '视频文件路径',
        show: false,
        detail: false,
      }, {
        field: 'thumbnailPath',
        label: '封面',
        show: true,
        img: true,
        detail: true,
      }, {
        field: 'videoDescription',
        label: '视频描述',
        show: false,
        detail: false,
      },
      {
        field: 'videoTags',
        label: '标签',
        detail: false,
        show: true,
      }, {
        field: 'publishTime',
        label: '预发布时间',
        show: false,
        detail: false,
      }, {
        field: 'actualPublishTime',
        label: '实际发布时间',
        show: false,
        detail: false,
      }, {
        field: 'keyWord',
        label: '关键词',
        show: false,
        detail: true,
      }, {
        field: 'productLink',
        label: '商品链接',
        detail: true,
        show: false,
      }, {
        field: 'productDescription',
        label: '商品描述',
        detail: true,
        show: false,
      }, {
        field: 'commodityPrice',
        label: '商品价格',
        detail: true,
        show: false,
      }, {
        field: 'commission',
        label: '佣金',
        detail: true,
        show: false,
      }, {
        field: 'commissionRate',  // 字段名
        label: '佣金比例',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
        detail: true,
      }, {
        field: 'sellingPrice',  // 字段名
        label: '售价',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
        detail: true,
      }, {
        field: 'douYinName',
        label: '抖音名称',
        show: true,
        detail: false,
      },
      {
        field: 'douYinId',
        label: '抖音号',
        show: true,
        detail: false,
      }, {
        field: 'cookiesName',
        label: 'cookies名称',
        detail: false,
        show: true,
      }, {
        field: 'videoType',
        label: '视频类型',
        show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '二创',
            type: 'info'
          }, {
            key: 1,
            value: 'AI视频',
            type: 'success'
          }]
        },
      }, {
        field: 'status',
        label: '状态',
        show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '发布失败',
            type: 'danger'
          }, {
            key: 1,
            value: '添加标签中',
            type: 'warning'
          }, {
            key: 2,
            value: '发布成功',
            type: 'success'
          }, {
            key: 3,
            value: '预发布',
            type: 'warning'
          }, {
            key: 4,
            value: '视频已采集',
            type: 'primary'
          }, {
            key: 5,
            value: '发布中',
            type: 'primary'
          }, {
            key: 6,
            value: '预约中',
            type: 'primary'
          }]
        },
        detail: false,
      }, {
        field: 'platformType',  // 字段名
        label: '平台类型',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,
        detail: true,
        selectData: [{
          id: 1,
          name: '抖音'
        }, {
          id: 2,
          name: '快手'
        }],
      }, {
        field: 'publishType',  // 字段名
        label: '发布类型',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,
        detail: true,
        selectData: [{
          id: 1,
          name: '短视频'
        }, {
          id: 2,
          name: '图文'
        }],
      }, {
        field: 'productCategoryId',
        label: '商品类别',
        selectUrl: '/productCategory/getAll',
        selectData: [],
        show: false,
        detail: true,
      }, {
        field: 'type',
        label: '方式',
        /*   show: {
             type: 'tag',
             tags: [{
               key: 1,
               value: '用户添加',
               type: 'warning'
             },{
               key: 2,
               value: '后台添加',
               type: 'primary'
             }]
           },*/
        show: false,
        detail: true,
      }, {
        field: 'callbackLog',
        label: '回调日志',
        show: true,
        detail: false,
      }, {
        field: 'callbackTime',
        label: '回调时间',
        show: true,
        detail: false,
      }, {
        field: 'path',
        label: '存储路径',
        detail: true,
        show: false,
      }, {
        field: 'videoSize',
        label: '视频长度',
        show: false,
        detail: true,
      }, {
        field: 'taskTime',
        label: '任务时间',
        show: false,
        detail: false,
      }, {
        field: 'receiveTime',
        label: '领取时间',
        show: false,
        detail: true,
      }, {
        field: 'productId',
        label: '商品ID',
        show: false,
        detail: true,
      }, {
        field: 'devices',
        label: '设备',
        show: true,
        detail: true,
      }, {
        field: 'nasPath',
        label: 'nas数据存放地址',
        show: false,
        detail: true,
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
      }],
      operate: [
        {
          icon: 'el-icon-upload3',
          type: 'text',
          text: '上传',
          uploadVideo: true,
          url: this.reUrl + '/douYinRelease/upload/ossVideo',
          // 用于存储handle的row
          value: {},
          handle: (row) => {
            console.log('112233')
            this.value = row
          },
          success: (res) => {
            if (res.code === 0) {
              const value = JSON.parse(JSON.stringify(this.value))
              value.path = res.data
              value.status = 3
              this.$axios.post({
                url: '/douYinRelease/update',
                data: value,
                success: (data) => {
                  if (data.code === 0) {
                    this.$message.success('文件上传成功')
                    this.$set(this.value, 'path', value.path)
                    this.$refs.table.getData()
                  } else {
                    this.$message.error(data.msg ? data.msg : '文件上传失败')
                  }
                },
              })
            } else if (res.code === 102) {
              window.localStorage.removeItem('username')
              window.localStorage.removeItem('sessionId')
              window.parent.location.href = this.feUrl + '/login.html'
            }
          },
        },
        {
          icon: 'el-icon-video-camera',
          type: 'text',
          text: '播放存储mp4_url',
          playVideo: true,
          handle: (row) => {
            console.log(row.path, '123123')
            if (row.path) {
              this.showVideoVisible = true
              this.videoSrc = row.path
            }
          },
        },
        {
          icon: 'el-icon-download',
          type: 'text',
          text: '下载',
          downloadVideo: true,
          handle: (row) => {
            console.log(row, '123123')
            let id
            const urlString = row.productLink
            if (urlString) {
              let url, params
              try {
                url = new URL(urlString);
                params = new URLSearchParams(url.search)
              } catch (error) {
                this.$message.error('商品链接不正确')
                return
              }

              id = params.get('id')
              console.log(id)
              if (!id) {
                this.$message.error('商品链接中不包含id')
                return
              }
            } else {
              this.$message.error('商品链接为空')
              return
            }

            this.$message.success('视频开始下载')
            const videoUrl = row.path
            fetch(videoUrl)
              .then(response => response.blob())
              .then(blob => {
                console.log(blob.type)
                if (blob.type == 'video/mp4') {
                  const url = window.URL.createObjectURL(blob)
                  const a = document.createElement('a')
                  a.href = url
                  a.download = id + '.mp4'
                  document.body.appendChild(a);
                  a.click();
                  window.URL.revokeObjectURL(url);
                  document.body.removeChild(a);
                  this.$message.success('视频下载成功')
                } else {
                  this.$message.error('视频链接无效')
                }
              })
              .catch();
          },
        },
        {
          icon: 'el-icon-magic-stick',
          type: 'text',
          text: 'AI生成',
          handle: (row) => {
            console.log(row, '111')
            this.coverImg = row.thumbnailPath
            this.chooseRow = row
            if (!row.productLink) {
              message.warning('该记录没有商品链接');
              return
            }
            request.post({
              url: '/douYinRelease/getProductImage',
              data: {
                productLink: row.productLink,
                agentId: row.agentId,
              },
              success: (res) => {
                console.log(res)
                if (res.code === 0) {
                  if (res.data) {
                    this.aiGenerateImages = res.data.slice(0, 5);
                  }
                  this.aiGenerateVisible = true;
                  setTimeout(() => {
                    console.log(document.querySelectorAll('.el-radio__input input'))
                    document.querySelectorAll('.el-radio__input input').forEach(input => {
                      input.removeAttribute('aria-hidden');
                    });
                  }, 10)
                } else {
                  message.error(res.msg);
                }
              }
            });
          }
        },
        {
          icon: 'el-icon-magic-stick',
          type: 'text',
          text: '更新AI生成状态',
          handle: (row) => {
            console.log(row, '111')
            request.post({
              url: '/douYinRelease/updateVideoStatus',
              data: row,
              success: (res) => {
                console.log(res)
                if (res.code === 0) {
                  message.success("更新状态成功");
                  this.$refs.table.getData()
                } else {
                  message.error(res.msg);
                }
              }
            });
          }
        }
      ],
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量发布',
        permission: 'douYinRelease:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要发布的数据')
            return
          }
          request.post({
            url: '/userInfo/getAllInfo',
            success: (data) => {
              if (data.code == 0) {
                console.log(data, "123123")
                this.userIds = data.data;
                this.batchForm.ids = this.selectIds.join(",")
                this.batchVisible = true
              }
            }
          });
        }
      }, {
        icon: 'el-icon-info',
        type: 'info',
        text: '批量修改抖音号',
        permission: 'douYinRelease:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要发布的数据')
            return
          }
          this.batchForm.ids = this.selectIds.join(",")
          this.batchUpdateDouYinIdVisible = true
        }
      }, {
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量预发布',
        permission: 'douYinRelease:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要预发布的数据')
            return
          }
          this.batchForm.ids = this.selectIds.join(",")
          request.post({
            url: '/douYinRelease/batchPreRelease',
            data: this.batchForm,
            success: (res) => {
              if (res.code === 0) {
                message.success("批量修改抖音号成功");
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          });
        }
      }, {
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量添加标签中',
        permission: 'douYinRelease:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('批量添加标签中')
            return
          }
          this.batchForm.ids = this.selectIds.join(",")
          request.post({
            url: '/douYinRelease/batchAddTags',
            data: this.batchForm,
            success: (res) => {
              if (res.code === 0) {
                message.success("批量修改抖音号成功");
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          });
        }
      }, {
        icon: 'el-icon-info',
        type: 'info',
        text: '批量修改cookies',
        permission: 'douYinRelease:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改的数据')
            return
          }
          this.batchCookiesForm.ids = this.selectIds.join(",")
          this.batchUpdateCookiesVisible = true
        }
      }, {
        icon: 'el-icon-download',
        type: 'warning',
        text: '导出',
        permission: 'douYinRelease:export',
        click: () => {
          this.tableColumns.some(item => {
            if (item.field == 'agentId') {
              this.agents = item.selectData;
            }
          })
          this.exportVisible = true;
        },
      },
      {
        icon: 'el-icon-circle-check',
        type: 'info',
        text: '批量修改代理',
        permission: 'douYinRelease:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改的数据')
            return
          }
          request.post({
            url: '/agent/getAll',
            success: (data) => {
              if (data.code == 0) {
                console.log(data)
                this.agents = data.data;
                this.batchAgent.ids = this.selectIds.join(",")
                this.batchUpdateAgent = true
              }
            }
          });
        },
      }
      ],
      formFields: {
        addTitle: '抖音预发布管理添加',
        updateTitle: '抖音预发布管理修改',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules: [{ required: true, message: '请选择代理', trigger: 'blur' }],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }, {
          field: 'videoTags',
          label: '视频话题标签',
          type: 'input',
          placeholder: '视频话题标签',
          rules: [{ message: '请输入视频话题标签', trigger: 'blur', required: false }],
          add: true,
          update: true,
        }, {
          field: 'productLink',
          label: '商品链接',
          type: 'input',
          placeholder: '商品链接',
          rules: [{ message: '请输入商品链接', trigger: 'blur', required: false }],
          add: true,
          update: true,
        }, {
          field: 'productDescription',
          label: '商品描述',
          type: 'input',
          placeholder: '商品描述',
          rules: [{ message: '请输入商品描述', trigger: 'blur', required: false }],
          add: true,
          update: true,
        }, {
          field: 'videoTitle',
          label: '视频标题',
          type: 'input',
          placeholder: '视频标题',
          rules: [{ message: '请输入视频标题', trigger: 'blur', required: false }],
          add: true,
          update: true,
        }, {
          field: 'cookiesName',
          label: 'cookies名称',
          type: 'input',
          placeholder: 'cookies名称',
          rules: [{ message: '请输入cookies名称', trigger: 'blur', required: false }],
          add: true,
          update: true,
        }, {
          field: 'videoType',
          label: '视频类型',
          type: 'select',
          placeholder: '请选择视频类型',
          rules: [{ required: true, message: '请选择视频类型', trigger: 'blur' }],
          selectData: [{
            id: 0,
            name: '二创'
          }, {
            id: 1,
            name: 'AI视频'
          }],
          add: true,
          update: true,
        }, {
          field: 'douYinId',
          label: '抖音号',
          type: 'input',
          placeholder: '抖音号名称',
          rules: [{ message: '请输入抖音号名称', trigger: 'blur', required: false }],
          add: true,
          update: true,
        }, {
          field: 'path',
          label: '存储路径',
          type: 'input',
          placeholder: '存储路径',
          rules: [{ message: '请输入存储路径', trigger: 'blur', required: false }],
          add: true,
          update: true,
        }, {
          field: 'nasPath',
          label: 'NAS存储路径',
          type: 'input',
          placeholder: 'NAS存储路径',
          rules: [{ message: '请输入NAS存储路径', trigger: 'blur', required: false }],
          add: true,
          update: true,
        }, {
          field: 'thumbnailPath',
          label: '视频封面',
          type: 'input',
          placeholder: '视频封面',
          rules: [{ message: '请输入视频封面', trigger: 'blur', required: false }],
          add: true,
          update: true,
        }, {
          field: 'status',
          label: '状态：',
          type: 'select',
          placeholder: '请选择状态',
          rules: [{ required: true, message: '请选择状态', trigger: 'blur' }],
          selectData: [{
            id: 3,
            name: '预发布'
          }, {
            id: 1,
            name: '添加标签'
          }, {
            id: 4,
            name: '添加商品'
          }, {
            id: 5,
            name: '发布中'
          }, {
            id: 2,
            name: '发布成功'
          }, {
            id: 0,
            name: '发布失败'
          }],
          // add: true,
          update: true,
          filterable: true,
        }, {
          field: 'aiVideoStatus',
          label: 'Ai生成状态：',
          type: 'select',
          placeholder: '请选择状态',
          rules: [{ required: false, message: '请选择状态', trigger: 'blur' }],
          selectData: [{
            id: 3,
            name: '生成失败'
          }, {
            id: 1,
            name: '已提交'
          }, {
            id: 2,
            name: '生成成功'
          }, {
            id: 0,
            name: '未发布'
          }],
          // add: true,
          update: true,
          filterable: true,
        }, {
          field: 'productCategoryId',
          label: '商品类别：',
          type: 'select',
          placeholder: '请选择商品类别',
          rules: [{ required: false, message: '请选择商品类别', trigger: 'blur' }],
          selectUrl: '/productCategory/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }, {
          field: 'platformType',
          label: '平台类型：',
          type: 'select',
          placeholder: '请选择状态',
          rules: [{ required: true, message: '请选择状态', trigger: 'blur' }],
          selectData: [{
            id: 1,
            name: '抖音'
          }, {
            id: 2,
            name: '快手'
          }],
          // add: true,
          update: true,
          filterable: true,
        }, {
          field: 'taskTime',
          label: '任务时间',
          type: 'dateTime',
          placeholder: '任务时间',
          add: false,
          update: false,
        }, {
          field: 'userId',
          label: '手机号：',
          type: 'select',
          placeholder: '请选择手机号',
          rules: [{ required: false, message: '请选择手机号', trigger: 'blur' }],
          selectUrl: '/userInfo/getAllInfo',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }],
      },
      aiGenerateVisible: false,
      aiGenerateForm: {},

      aiGenerateImages: [],
      chooseImage: '',
      chooseRow: null,
      coverImg: '',
      aiPrompt: ''
    }
  },
  methods: {
    returnId(data) {
      this.selectIds = data;
      console.log(this.selectIds)
    },
    vieoUpdate(data) {
      this.operate[0].value = data
      this.$refs.table.getData()
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitBatch(formName) {
      // console.log(this.batchForm, "123123")
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/douYinRelease/batchRelease',
            data: this.batchForm,
            confirm: '确定批量发布？',
            success: (res) => {
              if (res.code === 0) {
                message.success("批量发布成功");
                this.batchVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },

    submitDouYinIdBatch(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/douYinRelease/batchDouYinId',
            data: this.batchForm,
            confirm: '确定修改抖音号？',
            success: (res) => {
              if (res.code === 0) {
                message.success("批量修改抖音号成功");
                this.batchUpdateDouYinIdVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },
    submitCookiesBatch(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/douYinRelease/batchCookies',
            data: this.batchCookiesForm,
            confirm: '确定修改Cookies？',
            success: (res) => {
              if (res.code === 0) {
                message.success("批量修改Cookies成功");
                this.batchUpdateCookiesVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.get({
            url: '/douYinRelease/export',
            data: this.form,
            confirm: '确定导出Excel？',
            //responseType: 'arraybuffer',
            success: (res) => {
              if (res.code === 0) {
                message.success("自动选品信息导出任务正在进行中");
                this.exportVisible = false;
              } else {
                message.error(res.msg);
              }
              /*if (res.code) {
                  message.error(res.msg);
                  return;
              }
              excelDownload(res, "会员信息导出明细.xlsx");
              /!*this.$msgbox({
                  title: '下载地址',
                  message: '下载地址为：' + res.data + '，点击确定跳转下载！'
              }).then(() => {
                  window.open(res.data,"_blank");
              }).catch()*!/
              this.exportVisible = false;*/
            }
          })
        }
      })
    },
    submitAgent(formName) {
      console.log(this.batchAgent, "123123")
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/douYinRelease/batchAgent',
            data: this.batchAgent,
            confirm: '批量修改代理？',
            success: (data) => {
              if (data.code === 0) {
                message.success("批量修改代理成功");
                this.batchUpdateAgent = false;
                this.$refs.table.getData()
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      })
    },
    resetAIGenerateForm() {
      this.chooseImage = null
      this.generateQuantity = ''
      this.aiCreateWord = ""
      this.aiGenerateImages = []
      this.aiPrompt = 0
    },
    submitAIGenerateForm() {
      console.log(this.chooseImage)
      if (this.chooseImage == null) {
        message.warning('请选择图片')
        return
      }
      if (!this.aiCreateWord && !this.aiGenerateForm.aiPrompt) {
        message.warning('请输入提示词或勾选使用AI提示');
        return;
      }
      if (!this.generateQuantity) {
        message.warning('请输入生成数量')
        return
      }
      if (this.chooseImage == 'fengmian') {
        this.chooseRow.img = this.chooseRow.thumbnailPath
      } else {
        this.chooseRow.img = this.aiGenerateImages[this.chooseImage].imageUrl
      }

      // 这里后续可添加点击确定按钮后的接口请求逻辑
      this.chooseRow.prompt = this.aiCreateWord
      this.chooseRow.generateQuantity = this.generateQuantity
      this.chooseRow.aiPrompt = this.aiGenerateForm.aiPrompt ? 1 : 0;

      console.log('选中的：', this.chooseRow);
      request.post({
        url: '/douYinRelease/generateVideo',
        data: this.chooseRow,
        success: (res) => {
          if (res.code === 0) {
            message.success("选择图片成功");
            this.$refs.table.getData()
            this.aiGenerateVisible = false;
          } else {
            message.error(res.msg);
            this.aiGenerateVisible = false;
          }
        }
      });
      this.aiCreateWord = ""
    }
  }
}
</script>

<style scoped>
.product_video {
  width: 80%;
  margin-left: 10%;
}

.dialog_body_aiCreate {
  padding: 50px;
}

.totalImgBox {
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}

.noDataText {
  padding-left: 20px;
}

.radioBox {
  padding-bottom: 50px;
  width: 30%;
  /* padding-right: 80px; */
}

/deep/ .el-radio__inner {
  width: 20px !important;
  height: 20px !important;
}

.input_ai {
  width: 300px !important;
  margin-right: 50px;
}

.coverImg {
  padding: 20px 0;
}

.coverImg_text {
  font-size: 22px;
  color: #000;
  padding-bottom: 10px;
}

.coverImg img {
  height: 200px;
  width: 200px;
}

.coverBox {
  padding: 20px 0 5px 15px;
  font-size: 30px;
}

.coverTextBox {
  width: 200px;
}
</style>
